import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { AircraftResponse } from '../models/aircraft-response';

@Injectable({
  providedIn: 'root'
})
export class AircraftService {
  private url: string = environment.apiUrl + '/aircraft';

  constructor(private httpClient: HttpClient) {}

  getAircrafts(aircraftTypeId?: number | null): Observable<AircraftResponse> {
    let params = new HttpParams();

    if(aircraftTypeId)
      params = params.set('aircraftTypeId', aircraftTypeId);

    return this.httpClient.get<AircraftResponse>(this.url, { params });
  }
}
